import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ApplyButtonStyle } from "../../Constants";

function UpdateProfileButton({ job, fullWidth = false }) {
  return (
    <Box display="flex" flexDirection={"column"} width={"100%"} gap={1} justifyContent={"center"}>
      <Link to={"/jobs/apply"} state={{ selectedJob: job }}>
        <Button variant="contained" sx={ApplyButtonStyle} fullWidth={fullWidth}>
          Update Profile and Apply
        </Button>
      </Link>
      <Typography variant="body1" sx={{ color: "gray", textAlign: "center" }}>
        Your profile is incomplete
      </Typography>
    </Box>
  );
}

export default UpdateProfileButton;
